webpackJsonp([114276838955818,60335399758886],{

/***/ 106:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":" Diseño | Inbound Marketing | Desarrollo | Rem Agencia"}},"footerComponentData":{"cities":[{"id":1,"neigh":"Barrio Patria","phone":"3005215073","street":"Calle 86D # 30-49","title":"Bogotá"},{"id":2,"neigh":"El Poblado","phone":"3022570914","street":"Calle 7A Sur","title":"Medellín"}]},"headerComponentData":{"headers":[{"bgImage":"Barrio Patria","bgImage2":"Barrio Patria","headerLead":null,"id":1,"lead1":null,"lead2":null,"metaDescription":"","metaTitle":"3005215073","path":"Calle 86D # 30-49","title":"Bogotá"},{"bgImage":"https://firebasestorage.googleapis.com/v0/b/remagenciaadwords-201023.appspot.com/o/home%2Fcover_banner.png?alt=media&token=2662f983-a25d-47cb-92e7-37ba12625ab3","bgImage2":"https://firebasestorage.googleapis.com/v0/b/remagenciaadwords-201023.appspot.com/o/home%2FbgGral.png?alt=media&token=88d4cb7f-72fe-4f68-88bd-0144ca3bdeeb","headerLead":"Combinamos la estrategia creativa y digital, diseño estrategico y usabilidad, para construir productos únicos, que lleguen al usuario ideal.","id":2,"lead1":"UX","lead2":"UI","metaDescription":"Agencia digital y de desarrollo, creamos productos digitales combinando marketing de contenido, diseño estratégico y desarrollo, centrando cada detalle en el usuario final.","metaTitle":"Agencia Digital | Diseño Estratégico y Desarrollo de producto | Rem Agencia","path":"/","title":"Agencia Digital"},{"bgImage":"https://firebasestorage.googleapis.com/v0/b/remagenciaadwords-201023.appspot.com/o/home%2FbgGral.png?alt=media&token=88d4cb7f-72fe-4f68-88bd-0144ca3bdeeb","bgImage2":"https://firebasestorage.googleapis.com/v0/b/remagenciaadwords-201023.appspot.com/o/home%2FbgGral.png?alt=media&token=88d4cb7f-72fe-4f68-88bd-0144ca3bdeeb","headerLead":"Comprometidos 100% con la transformación digital, seguros de que con estrategia todo se puede.","id":3,"lead1":"","lead2":"","metaDescription":"Cuidamos cada detalle en el proceso de crear las estrategias, con nuestro equipo de diseño de intefaces móviles, planeamos cada detalle.","metaTitle":"Diseño de Intefaces Móviles | Rem Agencia","path":"about","title":"Nosotros"},{"bgImage":"https://firebasestorage.googleapis.com/v0/b/remagenciaadwords-201023.appspot.com/o/home%2FbgGral.png?alt=media&token=88d4cb7f-72fe-4f68-88bd-0144ca3bdeeb","bgImage2":"https://firebasestorage.googleapis.com/v0/b/remagenciaadwords-201023.appspot.com/o/home%2FbgGral.png?alt=media&token=88d4cb7f-72fe-4f68-88bd-0144ca3bdeeb","headerLead":"Nuestra pasión está representada en los productos digitales de alta calidad, con la experiencia centrada 100% en el usuario final.","id":4,"lead1":"","lead2":"","metaDescription":"Más que una agencia tradicional, somos especialistas realizar marketing de contenido, generando valor a los productos actuales y a tu negocio.","metaTitle":"Marketing de Contenidos | Diseño de Productos | Rem Agencia","path":"services","title":"Servicios"},{"bgImage":"https://firebasestorage.googleapis.com/v0/b/remagenciaadwords-201023.appspot.com/o/home%2FbgGral.png?alt=media&token=88d4cb7f-72fe-4f68-88bd-0144ca3bdeeb","bgImage2":"https://firebasestorage.googleapis.com/v0/b/remagenciaadwords-201023.appspot.com/o/home%2FbgGral.png?alt=media&token=88d4cb7f-72fe-4f68-88bd-0144ca3bdeeb","headerLead":"Queremos contarles todo lo que pasa en el mundo del marketing, diseño estratégico y tecnología.","id":5,"lead1":"","lead2":"","metaDescription":"En Rem Agencia estamos cada día investigando el mercado para tener las mejores soluciones digitales, enterate de toda la actualidad tecnológica.","metaTitle":"Actualidad Tecnológica | Rem Agencia","path":"blog","title":"Blog"},{"bgImage":"https://firebasestorage.googleapis.com/v0/b/remagenciaadwords-201023.appspot.com/o/home%2FbgGral.png?alt=media&token=88d4cb7f-72fe-4f68-88bd-0144ca3bdeeb","bgImage2":"https://firebasestorage.googleapis.com/v0/b/remagenciaadwords-201023.appspot.com/o/home%2FbgGral.png?alt=media&token=88d4cb7f-72fe-4f68-88bd-0144ca3bdeeb","headerLead":"¿ Quieres conocer más acerca de lo que te contamos ?","id":6,"lead1":"","lead2":"","metaDescription":"Estamos involucrados en cada proceso de tu proyecto, por eso somos la mejor Agencia Inbound. Escríbenos para ayudarte a crecer tu producto.","metaTitle":"Agencia Inbound | Rem Agencia","path":"contact","title":"Contacto"},{"bgImage":"https://firebasestorage.googleapis.com/v0/b/remagenciaadwords-201023.appspot.com/o/home%2FbgGral.png?alt=media&token=88d4cb7f-72fe-4f68-88bd-0144ca3bdeeb","bgImage2":"https://firebasestorage.googleapis.com/v0/b/remagenciaadwords-201023.appspot.com/o/home%2FbgGral.png?alt=media&token=88d4cb7f-72fe-4f68-88bd-0144ca3bdeeb","headerLead":"Hemos recibido tus datos, un asesor se comunicara contigo de inmediato.","id":7,"lead1":"","lead2":"","metaDescription":"Hemos recibido tu mensaje, ahora es nuestra tarea, planear y crear las mejores estratefias para indicarte que diseñamos tu futuro.","metaTitle":"Diseñamos tu futuro | Rem Agencia","path":"success","title":"Gracias"},{"bgImage":"https://firebasestorage.googleapis.com/v0/b/remagenciaadwords-201023.appspot.com/o/home%2FbgGral.png?alt=media&token=88d4cb7f-72fe-4f68-88bd-0144ca3bdeeb","bgImage2":"https://firebasestorage.googleapis.com/v0/b/remagenciaadwords-201023.appspot.com/o/home%2FbgGral.png?alt=media&token=88d4cb7f-72fe-4f68-88bd-0144ca3bdeeb","headerLead":"","id":8,"lead1":"","lead2":"","metaDescription":"Si eres una persona apasionada por el marketing, ven y creemos juntos los mejores productos digitales","metaTitle":"Creemos juntos los mejores productos digitales | Rem Agencia","path":"careers","title":"Trabaja en REM"},{"bgImage":null,"bgImage2":null,"headerLead":null,"id":9,"lead1":null,"lead2":null,"metaDescription":"Apple WWDC 2018","metaTitle":"Apple WWDC 2018 | Rem Agencia","path":"apple-wwdc","title":"Apple WWDC 2018"},{"bgImage":null,"bgImage2":null,"headerLead":null,"id":10,"lead1":null,"lead2":null,"metaDescription":"Aplicaciones Web Progresivas","metaTitle":"Aplicaciones Web Progresivas | Rem Agencia","path":"pwa","title":"Aplicaciones Web Progresivas"},{"bgImage":null,"bgImage2":null,"headerLead":null,"id":11,"lead1":null,"lead2":null,"metaDescription":"Optimización de sitios web para los buscadores.","metaTitle":" Optimización en motores de búsqueda y Optimización web | Rem Agencia","path":"seo_rem","title":"Optimizar web"},{"bgImage":"https://firebasestorage.googleapis.com/v0/b/remagenciaadwords-201023.appspot.com/o/home%2Fcover_banner.png?alt=media&token=2662f983-a25d-47cb-92e7-37ba12625ab3","bgImage2":"https://firebasestorage.googleapis.com/v0/b/remagenciaadwords-201023.appspot.com/o/home%2FbgGral.png?alt=media&token=88d4cb7f-72fe-4f68-88bd-0144ca3bdeeb","headerLead":"Nuestros proyectos nos hacen orgullosos","id":12,"lead1":null,"lead2":null,"metaDescription":"Agencia digital, expertos en diseño y creatividad en la creación de productos digitales.","metaTitle":"Agencia Digital | Consultores en diseño | Rem Agencia","path":"/portfolio","title":"Portafolio"}]}},"layoutContext":{}}

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(217);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(106);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(309);
	var isArguments = __webpack_require__(308);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 308:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 309:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(474);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(307);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(454);
	
	var _HelmetConstants = __webpack_require__(184);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 184:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(184);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(316));
	var shallowEqual = _interopDefault(__webpack_require__(491));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 491:
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),

/***/ 379:
/***/ (function(module, exports) {

	module.exports = {"contents":[{"id":1,"description":"footer","cities":[{"title":"Bogotá","street":"Calle 86D # 30-49","neigh":"Barrio Patria","phone":"3005215073","id":1},{"title":"Medellín","street":"Calle 7A Sur","neigh":"El Poblado","phone":"3022570914","id":2}]},{"id":2,"description":"home","projects_featured":[{"id":1,"className":"FeaturedProjects","title":"Wabii","work":"01. Research / UX / UI / Dev","text":"Aplicación de publicidad movil en vehículos, AI para lectura de data, desarrollo escalable para Android y iOS.","image":"../images/featured_wabii.png","bgImage":"../images/bg_section1.svg","bg":"","commentAuthor":"Jose Perez","commentAuthorProfile":"../images/profile_wabii.png","commentAuthorText":"Recibimos la mejor disposición un equipo muy bien preaparado para ejecutar el proyecto, conocimiento en tecnologías innovadores que nos beneficiaron, diseño muy solido."},{"id":2,"className":"FeaturedProjects","title":"Teleapp","work":"02. UX / UI / Dev","text":"Aplicación mobil de uso operativo para los supervisores y comerciales. Desarrollado para Android y iOS.","image":"../images/featured_tele.png","bgImage":"../images/bg_section2.svg","bg":"","commentAuthor":"Freddy Murcia","commentAuthorProfile":"../images/profile_tele.jpg","commentAuthorText":"Un trabajo magnífico y un soporte de una calidad que supero nuestras expectativas. Cuentan con un equipo de desarrollo que sabe lo que realiza."},{"id":3,"className":"FeaturedProjects","title":"RunWay","work":"03. Research / UX / UI / Dev","text":"Aplicación de retos en bicicleta, fidelización y redención de puntos, desarrollo escalable para Android y iOS.","image":"../images/featured_app.png","bgImage":"../images/bg_section4.svg","bg":"","commentAuthor":"Mark Steven","commentAuthorProfile":"../images/profile_runway.jpg","commentAuthorText":"The most great team for a digital products, we work together over a product unique."}]},{"id":3,"description":"services","service":[{"title1":"Diseño","title2":"Inteligente","street":"Calle 86D # 30-49","neigh":"Barrio Patria","id":1},{"title1":"Marketing","title2":"Digital","street":"Madison Avenue","neigh":"Manhattan","id":2}]}]}

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BgImage = function BgImage(props) {
		return _react2.default.createElement(
			"div",
			{ className: "BgImage" },
			props.bgImage && _react2.default.createElement(
				"div",
				{ className: "BgImage" },
				_react2.default.createElement("img", { src: props.bgImage, alt: "" })
			),
			props.bgImage2 && _react2.default.createElement(
				"div",
				{ className: "BgImage" },
				_react2.default.createElement("img", { src: props.bgImage2, alt: "" })
			)
		);
	};
	
	exports.default = BgImage;
	module.exports = exports["default"];

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _location = __webpack_require__(507);
	
	var _location2 = _interopRequireDefault(_location);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Cities = function Cities(props) {
	  console.log('New Cities', props);
	  return _react2.default.createElement(
	    'div',
	    { className: 'cities' },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        props.title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'FooterIcons' },
	        _react2.default.createElement(
	          'i',
	          null,
	          _react2.default.createElement('img', { src: _location2.default, alt: '' })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          props.street,
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'strong',
	            null,
	            props.neigh
	          ),
	          ' ',
	          _react2.default.createElement('br', null),
	          ' ',
	          props.phone
	        )
	      )
	    )
	  );
	};
	
	exports.default = Cities;
	module.exports = exports['default'];

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cities = __webpack_require__(204);
	
	var _cities2 = _interopRequireDefault(_cities);
	
	var _sitemap = __webpack_require__(216);
	
	var _sitemap2 = _interopRequireDefault(_sitemap);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(382);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_Component) {
		_inherits(Footer, _Component);
	
		function Footer(props) {
			_classCallCheck(this, Footer);
	
			return _possibleConstructorReturn(this, _Component.call(this, props));
		}
	
		Footer.prototype.render = function render() {
			// console.log(this.props.footerData)
			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'div',
					{ className: 'FooterWrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'FooterContent ' },
						this.props.footerData.map(function (item) {
							// return <Cities title={item.title} key={item.id} /> // 
							// return <Cities {...item} key={item.id} /> // Spread Operator {...item}
							return _react2.default.createElement(_cities2.default, _extends({}, item, { key: item.id })); // Spread Operator {...item}
						}),
						_react2.default.createElement(_sitemap2.default, null)
					),
					_react2.default.createElement(
						'div',
						{ className: 'FooterBtn' },
						_react2.default.createElement(
							'a',
							{ href: 'https://www.facebook.com/remagencia/', target: 'blank' },
							'Facebook'
						),
						_react2.default.createElement(
							'a',
							{ href: 'https://dribbble.com/remagencia', target: 'blank' },
							'Dribbble'
						),
						_react2.default.createElement(
							'a',
							{ href: 'https://www.instagram.com/remagencia/' },
							'Instagram'
						),
						_react2.default.createElement(
							'a',
							{ href: 'https://www.youtube.com/channel/UCgrJg_4X9ZkoMaEKi2yjApQ', target: 'blank' },
							'Youtube'
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'academy-badge' },
					_react2.default.createElement(
						'a',
						{ href: 'https://hubspot-academy.s3.amazonaws.com/prod/tracks/user-certificates/22-5749215-1534726831431.png', title: 'Inbound' },
						_react2.default.createElement('img', { src: 'https://hubspot-academy.s3.amazonaws.com/prod/tracks/user-badges/22-5749215-1534726831569.png' })
					)
				)
			);
		};
	
		return Footer;
	}(_react.Component);
	
	Footer.propTypes = {
		name: _react2.default.PropTypes.string
	};
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 382:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _bgimage = __webpack_require__(203);
	
	var _bgimage2 = _interopRequireDefault(_bgimage);
	
	var _headerMedia = __webpack_require__(209);
	
	var _headerMedia2 = _interopRequireDefault(_headerMedia);
	
	var _seo = __webpack_require__(129);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeaderContent = function HeaderContent(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'IntroHome' },
	    _react2.default.createElement(_seo2.default, { titleSection: props.metaTitle, metaDescription: props.metaDescription }),
	    _react2.default.createElement(_headerMedia2.default, { image: props.bgImage }),
	    _react2.default.createElement(_bgimage2.default, { bgImage: props.bgImag2, bgImage2: props.bgImag2 }),
	    _react2.default.createElement(
	      'div',
	      { className: 'leads leads-blur' },
	      props.lead1
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'leads leads-center' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          props.title
	        ),
	        _react2.default.createElement('div', { className: 'divide-content' }),
	        _react2.default.createElement(
	          'p',
	          { className: 'headerLead' },
	          props.headerLead
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'button',
	            to: '/contact/',
	            style: { color: 'white', textDecoration: 'none' } },
	          ' Cont\xE1ctanos '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'leads leads-blur' },
	      props.lead2
	    )
	  );
	};
	
	exports.default = HeaderContent;
	module.exports = exports['default'];

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MediaHeader = function MediaHeader(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "HeaderMedia" },
	    _react2.default.createElement("img", { src: props.image, alt: "" })
	  );
	};
	
	exports.default = MediaHeader;
	module.exports = exports["default"];

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _navModal = __webpack_require__(214);
	
	var _navModal2 = _interopRequireDefault(_navModal);
	
	var _navIcon = __webpack_require__(213);
	
	var _navIcon2 = _interopRequireDefault(_navIcon);
	
	var _headerContent = __webpack_require__(208);
	
	var _headerContent2 = _interopRequireDefault(_headerContent);
	
	var _logov2_dark = __webpack_require__(508);
	
	var _logov2_dark2 = _interopRequireDefault(_logov2_dark);
	
	__webpack_require__(159);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// MEDIA
	
	
	// STYLES
	
	
	var Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      navigator: false
	    };
	
	    _this.openNavigator = function (e) {
	      _this.setState({
	        navigator: !_this.state.navigator
	      });
	    };
	
	    console.log(props);
	    return _this;
	  }
	
	  Header.prototype.componentDidMount = function componentDidMount() {
	    var script = document.createElement("script");
	
	    script.type = 'application/ld+json';
	    script.innerHTML = '\n          {\n            "@context": "http://schema.org",\n            "@type": "Organization",\n            "url": "http://www.remagencia.com/",\n            "logo": "http://aremlab.com/img/logo_red.png",\n            "contactPoint": [{\n              "@type": "ContactPoint",\n              "telephone": "+57-302-257-0914",\n              "contactType": "customer service"\n            }]\n          }\n        ';
	    script.async = true;
	
	    document.body.appendChild(script);
	  };
	
	  Header.prototype.render = function render() {
	    var locationPath = this.props.location.pathname;
	    return _react2.default.createElement(
	      'div',
	      { className: 'HeaderWrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'HeaderContainer' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            className: 'logo',
	            to: '/',
	            style: {
	              color: 'white',
	              textDecoration: 'none'
	            } },
	          _react2.default.createElement('img', { src: _logov2_dark2.default, onClick: this.handleClickHome, alt: '' })
	        ),
	        _react2.default.createElement(_navIcon2.default, {
	          className: 'NavIcon',
	          size: 27,
	          color: '#DF1F38',
	          navigator: this.state.navigator,
	          handleClick: this.openNavigator }),
	        this.state.navigator && _react2.default.createElement(_navModal2.default, {
	          className: 'NaviModal',
	          handleClick: this.openNavigator
	        })
	      ),
	      this.props.headerData.map(function (item) {
	        if (locationPath === '/' + item.path + '/') {
	          return _react2.default.createElement(_headerContent2.default, _extends({}, item, { key: item.id }));
	        } else if (locationPath === item.path) {
	          return _react2.default.createElement(_headerContent2.default, _extends({}, item, { key: item.id }));
	        }
	      })
	    );
	  };
	
	  return Header;
	}(_react.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 159:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Icon(props) {
	  var color = props.color,
	      size = props.size;
	
	  return _react2.default.createElement(
	    "svg",
	    {
	      fill: color,
	      height: size,
	      width: size,
	      viewBox: "0 0 32 32"
	    },
	    props.children
	  );
	}
	
	exports.default = Icon;
	module.exports = exports["default"];

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _icon = __webpack_require__(212);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function NavIcon(props) {
		console.log('Nav Icon', props);
		return _react2.default.createElement(
			'div',
			null,
			!props.navigator ? _react2.default.createElement(
				'button',
				{
					onClick: props.handleClick
				},
				_react2.default.createElement(
					_icon2.default,
					props,
					_react2.default.createElement('path', { d: 'm0 28h43v3h-43zm0-14h43v3h-43zm0-14h43v3h-43z' })
				)
			) : _react2.default.createElement(
				'button',
				{
					onClick: props.handleClick
				},
				_react2.default.createElement(
					_icon2.default,
					props,
					_react2.default.createElement('path', { d: 'm14 1.4-1.4-1.4-5.6 5.6-5.6-5.6-1.4 1.4 5.6 5.6-5.6 5.6 1.4 1.4 5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6z' })
				)
			)
		);
	}
	
	exports.default = NavIcon;
	module.exports = exports['default'];

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(159);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NaviModal = function NaviModal(props) {
	      return _react2.default.createElement(
	            'nav',
	            null,
	            _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/', onClick: props.handleClick },
	                  'Inicio'
	            ),
	            _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/portfolio', onClick: props.handleClick },
	                  'Portafolio'
	            ),
	            _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/about/', onClick: props.handleClick },
	                  'Nosotros'
	            ),
	            _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/services/', onClick: props.handleClick },
	                  'Servicios'
	            ),
	            _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/careers/', onClick: props.handleClick },
	                  'Trabajo'
	            ),
	            _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/blog/', onClick: props.handleClick },
	                  'Blog'
	            ),
	            _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/contact/', onClick: props.handleClick },
	                  'Contacto'
	            )
	      );
	};
	
	exports.default = NaviModal;
	module.exports = exports['default'];

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(183);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SEO = function SEO(props) {
				console.log(props);
				return _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(_reactHelmet2.default, {
										title: props.titleSection,
										meta: [{ name: "description", content: props.metaDescription }, { name: "image", content: "http://www.remagencia.com/images/about-gallery.png" }, { itemprop: "name", content: "Rem Agencia" }, { name: "twitter:card", content: "summary" }, { name: "twitter:title", content: "Rem Agencia" }, { name: "twitter:description", content: props.metaDescription }, { name: "twitter:image:src", content: "http://www.remagencia.com/images/about-gallery.png" }, { name: "og:title", content: "Rem Agencia" }, { name: "og:description", content: props.metaDescription }, { name: "og:image", content: "http://www.remagencia.com/images/about-gallery.png" }, { name: "og:url", content: "http://www.remagencia.com" }, { name: "og:site_name", content: "Rem Agencia" }, { name: "og:locale", content: "en_ES" }, { name: "og:type", content: "website" }]
							})
				);
	};
	
	exports.default = SEO;
	module.exports = exports['default'];

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SiteMap = function SiteMap(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'sitemap' },
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/', style: {
	              color: '#F6F6F6',
	              textDecoration: 'none'
	            } },
	          'Inicio'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/services/', style: {
	              color: '#F6F6F6',
	              textDecoration: 'none'
	            } },
	          'Servicios'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/about/', style: {
	              color: '#F6F6F6',
	              textDecoration: 'none'
	            } },
	          'Nosotros'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/contact/', style: {
	              color: '#F6F6F6',
	              textDecoration: 'none'
	            } },
	          'Contacto'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/blog/', style: {
	              color: '#F6F6F6',
	              textDecoration: 'none'
	            } },
	          'Blog'
	        )
	      )
	    )
	  );
	};
	
	exports.default = SiteMap;
	module.exports = exports['default'];

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjQ4IiB2aWV3Qm94PSIwIDAgMzMgNDgiIHdpZHRoPSIzMyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMjIuMTczODI5MiAyMDIuMzI1Yy0zLjI1NjIwMjEgMC01LjkwNDYzMzQtMi42NTY0ODEtNS45MDQ2MzM0LTUuOTE2NzA4IDAtMy4yNDY4MTEgMi42NDg0MzEzLTUuOTAzMjkyIDUuOTA0NjMzNC01LjkwMzI5MiAzLjI1NjIwMiAwIDUuOTA1OTc1IDIuNjU2NDgxIDUuOTA1OTc1IDUuOTAzMjkyIDAgMy4yNjAyMjctMi42NDk3NzMgNS45MTY3MDgtNS45MDU5NzUgNS45MTY3MDh6bS4wMDAxNzA4LTEzLjMxNWMtNC4wODEgMC03LjQwMSAzLjMyLTcuNDAxIDcuNCAwIDQuMDkgMy4zMiA3LjQxIDcuNDAxIDcuNDEgNC4wODIgMCA3LjQwMi0zLjMyIDcuNDAyLTcuNDEgMC00LjA4LTMuMzItNy40LTcuNDAyLTcuNHptMTMuNzM0ODU0MiAxMS42NDEwMjZjLS4zNTU2MTU3IDEuNDA3NDIyLTEuNjI1NTE4NiA0LjE3OTI5MS0yLjY0MDc5NjIgNS43NDc4NjgtLjUwMDY1NTQuODM4MDA3LTcuOTQzODc2IDEzLjUxNTU0OC0xMS4xMjgzMDI0IDE4Ljk0MTEwNmwtMTEuODU2NzIzOS0yMC44NjQyMjQtLjA3NjI4MDEtLjEzOTY2OGMtLjMwMDgyMjk5LS41MzcxODQtLjkyNTAzMDczLTEuNjQzNzgzLTEuMzcwODkzMzktMy4wNTEyMDUtLjU2MTg5NDQtMS43ODM0NS0uODM1ODU4MjEtMy40NTk0NjQtLjgzNTg1ODIxLTUuMTI0NzM0IDAtNy44MTA2NTUgNi4zNDk1MTQxLTE0LjE2MDE2OSAxNC4xNTM3MjI0LTE0LjE2MDE2OSA4LjE2NDEyMTQgMCAxMy43MjYxMjM5IDYuNTQyOSAxNC4zODU3ODU4IDEyLjg2MDE4My4xNjc2MDE0IDEuNjAwODA5LS4wMzIyMzExIDMuNDQ4NzIxLS42MzA2NTQgNS43OTA4NDN6bTIuNjM5MTQ1OC01Ljk5MTAyNmMtLjg3Mi04LjM1LTcuOTExLTE0LjY2LTE2LjM3NC0xNC42Ni04LjkxOCAwLTE2LjE3NCA3LjI2LTE2LjE3NCAxNi4xOCAwIDEuODYuMzAxIDMuNzIuOTE4IDUuNjcuNTA4IDEuNjEgMS4yMTggMi44NyAxLjUyMSAzLjQxbC4wNjkuMTJjLjAwMi4wMS4wMDUuMDEuMDA3LjAybDEyLjMyIDIxLjY3Yy4yNjUuNDcuNzU4Ljc2IDEuMjk0Ljc2aC4wMTFjLjUzMSAwIDEuMDIzLS4yOCAxLjI5My0uNzQuMTExLS4xOSAxMS4wODQtMTguODcgMTEuNjM0LTE5Ljc5Ljk5MS0xLjU0IDIuMzYxLTQuNCAyLjgxOC02LjE5LjY0Ni0yLjU1Ljg1Ny00LjU5LjY2My02LjQ1eiIgZmlsbD0iI2RlMWUzOCIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNiAtMTgwKSIvPjwvc3ZnPg=="

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 317:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(183);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _seo = __webpack_require__(129);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	var _header = __webpack_require__(210);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(206);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _api = __webpack_require__(379);
	
	var _api2 = _interopRequireDefault(_api);
	
	__webpack_require__(317);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = function Layout(_ref) {
	  var location = _ref.location,
	      children = _ref.children,
	      data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_header2.default, { siteTitle: data.site.siteMetadata.title, location: location, headerData: data.headerComponentData.headers }),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          margin: '0 auto',
	          paddingTop: 0
	        }
	      },
	      children()
	    ),
	    _react2.default.createElement(_footer2.default, { api: _api2.default, footerData: data.footerComponentData.cities })
	  );
	};
	
	// import Favicon from '../images/favicon.png'
	
	Layout.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-fd5c20dfab552be3829e.js